/**
 * True inside the iPad app's native shell (Capacitor, A2), false in any
 * browser. The shell provides what a page cannot: the Keychain for the device
 * credential, the system's viewer for a PDF. Until it does, the app says so
 * rather than falling back to what only works in a browser.
 */
export function isNativeShell(scope: unknown = globalThis): boolean {
  const capacitor = (scope as { Capacitor?: { isNativePlatform?: unknown } }).Capacitor
  return typeof capacitor?.isNativePlatform === 'function' && capacitor.isNativePlatform() === true
}
